module.exports = __webpack_public_path__ + "static/media/v2-explora-shopping.89779aad.jpg";